import * as React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid2";
import { Avatar, Box, Button, Divider, Typography } from "@mui/material";
import InstagramCarousel from "../Components/carousel";

const backgroundStyle = {
  backgroundImage: `
  linear-gradient( rgba(235, 1, 0, 0.8),rgba(0, 26, 255, 0.8),rgba(255, 188, 0, 0.8), rgba(203, 0, 255, 0.8)),
  url(https://i.postimg.cc/13Vy3p0z/background-png.png)
`,
  backgroundSize: "cover",
  backgroundPosition: "center", // Centraliza a imagem
  height: "100vh", // Define altura total da viewport
  width: "100%", // Define a largura completa
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  marginTop: "5rem",
  marginLeft: "2rem",
  marginRight: "2rem",
  textAlign: "center",
  alignContent: "center",
  borderRadius: "1rem",
  height: "80vh" /* Altura da tela inteira */,
  gridTemplateColumns: "1fr" /* Ou ajuste conforme necessário */,
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const Home = () => {
  return (
    <Grid container spacing={2} style={backgroundStyle}>
      <Grid size={{ sm: 5, md: 5 }}>
        <Item>
          <Box
            style={{
              marginTop: "-4rem",
              display: "flex",
              justifyContent: "center", 
              alignItems: "center",
            }}
          >
            <Avatar
              sx={{
                width: 140,
                height: 140,
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              }}
              alt="prefeituraDeCanindeSecretariaDeSaude"
              src="https://i.postimg.cc/52R1hB0F/logoprefeitura.png"
            />
          </Box>
          <Box
            style={{
              height: "calc(100% - 8rem)",
              marginTop: "1rem",
              overflowY: "scroll",
              scrollbarWidth: "none",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              style={{
                color: "black",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              Secretaria de Saúde
            </Typography>
           
              <Typography variant="subtitle1" gutterBottom>
                Clique abaixo e saiba onde encontrar atendimento:
              </Typography>
              <Button
                href="https://saude-direcionada.vercel.app"
                style={{
                  borderColor: "red",
                  color: "red",
                  width: "calc(100% - 4rem)",
                  borderWidth: "0.2rem",
                  borderRadius: "2rem",
                  marginTop: "0.5rem",
                  marginBottom: "1rem",
                }}
                variant="outlined"
              >
                Preciso de atendimento
              </Button>
              <Typography variant="subtitle1" gutterBottom>
                Clique abaixo e saiba a disponibilidade de vagas no transporte da saúde:
              </Typography>
              <Button
                href="https://sauderapidapacientes.vercel.app/"
                style={{
                  borderColor: "blue",
                  color: "blue",
                  width: "calc(100% - 4rem)",
                  borderWidth: "0.2rem",
                  borderRadius: "2rem",
                  marginTop: "0.5rem",
                  marginBottom: "1rem",
                }}
                variant="outlined"
              >
                Vagas no transporte
              </Button>
              <Box
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              <Divider style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                Campanha do mês:
              </Divider>
              <InstagramCarousel
                images={[
                  "https://i.postimg.cc/3r1JtZd0/CAMPANHA-MARCO.png",
                ]}
                interval={4000}
              />
            </Box>
            <Divider style={{ marginTop: "1rem", marginBottom: "1rem" }}>
              Mais informações
            </Divider>
            <Typography variant="caption" gutterBottom>
              E-mail: t.i.secretaria.de.saude.caninde@gmail.com <br></br>
              Endereço: R. Antônio Martins, 239 - Centro, Canindé - CE,
              62700-000
            </Typography>
            <Box>
              <img
                style={{
                  marginTop: "1rem",
                  maxHeight: "3rem", 
                  objectFit: "contain", 
                }}
                src="https://i.postimg.cc/fLW5nrbw/LOGO-PREFEITURA-SAUDE.png"
                alt="Imagem do public"
              />
            </Box>
          </Box>
        </Item>
      </Grid>
      <Grid
        sx={{
          display: { xs: "none", sm: "block" },
        }}
        size={{ sm: 7, md: 7 }}
      >
        <Item>
          <Typography
            variant="h5"
            gutterBottom
            style={{
              color: "black",
              fontWeight: "500",
              marginBottom: "0.5rem",
            }}
          >
            Campanha do mês
          </Typography>
          <Box
             sx={{
              height: "80%",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",}}
          >
            <img
               style={{
                height: "100%",  
                width: "auto",
                objectFit: "contain",
              }}
              src="https://i.postimg.cc/3r1JtZd0/CAMPANHA-MARCO.png"
              alt="Campanha do mês"
            />
          </Box>
        </Item>
      </Grid>
    </Grid>
  );
};

export default Home;
